import styles from "./header.module.scss";
import { IconButton } from "@mui/material";
import { ReactComponent as HamburgerMenuIcon } from "../../../svgs/hamburger-menu.svg";
import { ReactComponent as Avatar } from "../../../svgs/headerProfile.svg";
import { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";

interface HeaderProps {
  handleSidebarToggle?: () => void;
}

type DateTimeFormatOptions = {
  weekday?: "long" | "short" | "narrow";
  year?: "numeric" | "2-digit";
  month?: "numeric" | "2-digit" | "long" | "short" | "narrow";
  day?: "numeric" | "2-digit";
  hour?: "numeric" | "2-digit";
  timeZoneName?: "long" | "short";
};

const formatDate = (date: Date): string => {
  const options: DateTimeFormatOptions = {
    weekday: "long",
    day: "numeric",
    month: "long",
  };
  const formattedDate = date.toLocaleDateString("en-US", options);

  const day = date.getDate();
  let daySuffix = "th";

  if (day === 1 || day === 21 || day === 31) {
    daySuffix = "st";
  } else if (day === 2 || day === 22) {
    daySuffix = "nd";
  } else if (day === 3 || day === 23) {
    daySuffix = "rd";
  }

  return formattedDate.replace(/\d+/, `${day}${daySuffix}`);
};

const Header: React.FC<HeaderProps> = ({ handleSidebarToggle }) => {
  const username = useSelector((state: RootState) => state?.user?.name);
  //eslint-disable-next-line
  const [_, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <div className={styles.head}>
      <IconButton
        aria-label="open sidebar"
        edge="start"
        onClick={handleSidebarToggle}
        sx={{ mr: 0, visibility: { xs: "visible", md: "hidden" } }}
      >
        <HamburgerMenuIcon />
      </IconButton>
      <span className={styles.date}>{formatDate(new Date())}</span>
      <div className={styles.profileGroup}>
        <IconButton onClick={handleClick}>
          <Avatar />
        </IconButton>
        <span className={styles.text}>
          Hello{username ? ", " + username : null}
        </span>
      </div>
    </div>
  );
};

export default Header;
